export default __webpack_public_path__ + "static/dibk.dom-0fadfc64d943ea073aee3064d4774da7.jpg";